// extracted by mini-css-extract-plugin
export default {"collapse-button":"CollapseButton_collapse-button__aAkkL","collapsed":"CollapseButton_collapsed__64G2F"};